export const DIY_CONSENT_OTP_VERIFIED_KEY = 'diy_consent_otp_verified';

function sessionStore() {
  try {
    return typeof sessionStorage !== 'undefined' ? sessionStorage : null;
  } catch {
    return null;
  }
}

export function markDiyConsentOtpVerified() {
  const store = sessionStore();
  if (!store) {
    return;
  }
  try {
    store.setItem(DIY_CONSENT_OTP_VERIFIED_KEY, JSON.stringify(true));
  } catch {
    // ignore
  }
}

export function isDiyConsentOtpVerified() {
  const store = sessionStore();
  if (!store) {
    return false;
  }
  try {
    const raw = store.getItem(DIY_CONSENT_OTP_VERIFIED_KEY);
    return raw != null && raw !== '' && (JSON.parse(raw) === true || raw === 'true');
  } catch {
    return false;
  }
}
